export const KIFFGO = {
  phoneNumber: '0203 870 0974',
  phoneNumberFormal: '+44 (0) 2038 700 974',
  phoneNumberHrefLink: 'tel:+44 203 870 0974'
};
